module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-20.528ec42e.png";